"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.findMediaLinks = exports.isMediaLink = void 0;
function isMediaLink(link) {
    if ((link.type === "twitter" ||
        link.type === "external" ||
        link.type === "youtube" ||
        link.type === "bluesky") &&
        link.url) {
        return true;
    }
    return false;
}
exports.isMediaLink = isMediaLink;
function formatLink(type, url) {
    return {
        url: url.startsWith("http") ? url : `https://${url}`,
        type,
    };
}
const patterns = [
    {
        type: "youtube",
        pattern: /(https?:\/\/)?(www\.)?(youtube\.com\/watch\?v=[-_a-zA-z0-9]{1,12}|youtu\.be\/[-_a-zA-z0-9]{1,12})/g,
    },
    {
        type: "twitter",
        pattern: /(https?:\/\/)?(www\.|mobile\.)?(twitter\.com\/[a-zA-z0-9]+\/status\/[0-9]+)/g,
    },
    {
        type: "twitter",
        pattern: /(https?:\/\/)?(www\.|mobile\.)?(x\.com\/[a-zA-z0-9]+\/status\/[0-9]+)/g,
    },
    {
        type: "bluesky",
        pattern: /(https?:\/\/)?(bsky\.app)?(\/profile\/[a-zA-z0-9\.]+\/post\/[a-zA-z0-9\.]+)/g,
    },
];
function findMediaLinks(body) {
    const media = [];
    // For each of the patterns available...
    for (const { type, pattern } of patterns) {
        // Find all urls in the body with the pattern and put it into a set to
        // deduplicate it.
        const urls = new Set(body.match(pattern) || []);
        // For each of the unique urls, format the url to a media link and push it
        // in.
        Array.from(urls).forEach((url) => {
            media.push(formatLink(type, url));
        });
    }
    return media;
}
exports.findMediaLinks = findMediaLinks;
